module.exports = __webpack_public_path__ + "static/media/26-14.18f83731.mp3";